import { createAction } from '@reduxjs/toolkit';
import { RosterExpandable, RosterRequest, RosterResponse, RostersResponse, RosterStudentResponse, StudentInfo } from '../../Components/Modals/models';
import { ErrorResponse } from '../../shared';
import { RostersActionTypes } from './models';

export const fetchRostersStart = createAction(
  RostersActionTypes.FETCH_ROSTERS_START,
  (payload?: RosterResponse) => ({payload})
);

export const fetchRostersSuccess = createAction(
  RostersActionTypes.FETCH_ROSTERS_SUCCESS,
  (payload: RostersResponse) => ({payload})
);

export const fetchRostersFailure = createAction(
  RostersActionTypes.FETCH_ROSTERS_FAILURE,
  (payload: ErrorResponse) => ({payload})
);

export const addRosterStart = createAction(
  RostersActionTypes.ADD_ROSTER_START,
  (payload: RosterRequest) => ({payload})
);

export const addRosterSuccess = createAction(
  RostersActionTypes.ADD_ROSTER_SUCCESS,
  (payload: RosterResponse) => ({payload})
);

export const addRosterFailure = createAction(
  RostersActionTypes.ADD_ROSTER_FAILURE,
  (payload: ErrorResponse) => ({payload})
);

export const updateRosterStart = createAction(
  RostersActionTypes.UPDATE_ROSTER_START,
  (payload: RosterRequest) => ({payload})
);

export const updateRosterSuccess = createAction(
  RostersActionTypes.UPDATE_ROSTER_SUCCESS,
  (payload: RosterResponse) => ({payload})
);

export const updateRosterFailure = createAction(
  RostersActionTypes.UPDATE_ROSTER_FAILURE,
  (payload: ErrorResponse) => ({payload})
);

export const deleteRosterStart = createAction(
  RostersActionTypes.DELETE_ROSTER_START,
  (payload: RosterExpandable) => ({payload})
);

export const deleteRosterSuccess = createAction(
  RostersActionTypes.DELETE_ROSTER_SUCCESS,
  (payload: RosterResponse) => ({payload})
);

export const deleteRosterFailure = createAction(
  RostersActionTypes.DELETE_ROSTER_FAILURE,
  (payload: ErrorResponse) => ({payload})
);

export const fetchRosterStudentsStart = createAction(
  RostersActionTypes.FETCH_ROSTER_STUDENTS_START,
  (payload: RosterRequest) => ({payload})
);

export const fetchRosterStudentsSuccess = createAction(
  RostersActionTypes.FETCH_ROSTER_STUDENTS_SUCCESS,
  (payload: RosterStudentResponse) => ({payload})
);


export const fetchRosterStudentsFailure = createAction(
  RostersActionTypes.FETCH_ROSTER_STUDENTS_FAILURE,
  (payload: RosterStudentResponse) => ({payload})
);

export const deleteRosterStudentStart = createAction(
  RostersActionTypes.DELETE_ROSTER_STUDENT_START,
  (payload: StudentInfo) => ({payload})
);

export const deleteRosterStudentSuccess = createAction(
  RostersActionTypes.DELETE_ROSTER_STUDENT_SUCCESS,
  (payload: RosterResponse) => ({payload})
);

export const deleteRosterStudentFailure = createAction(
  RostersActionTypes.DELETE_ROSTER_STUDENT_FAILURE,
  (payload: ErrorResponse) => ({payload})
);

export const toggleRoster = createAction(
  RostersActionTypes.TOGGLE_ROSTER,
  (payload: RosterExpandable) => ({payload})
);

export const resetRosters = createAction(
  RostersActionTypes.RESET_ROSTERS
);